(function () {
  let sweeping = false;

  function bundleKey(item) {
    return item.properties ? item.properties['_date'] : null;
  }

  function isCharger(item) {
    return !!(item.properties && item.properties['_corecharger']);
  }

  function findOrphanChargers(items) {
    const parentKeys = new Set();
    items.forEach((item) => {
      if (!isCharger(item) && bundleKey(item)) parentKeys.add(bundleKey(item));
    });
    return items.filter((item) => isCharger(item) && !parentKeys.has(bundleKey(item)));
  }

  function removeViaRebuy(orphans) {
    const rebuyCart = window.Rebuy && window.Rebuy.Cart;
    if (!rebuyCart || typeof rebuyCart.removeItem !== 'function' || typeof rebuyCart.getItems !== 'function') {
      return false;
    }
    const rebuyItems = rebuyCart.getItems() || [];
    const matched = orphans
      .map((orphan) => rebuyItems.find((item) => item.key === orphan.key))
      .filter(Boolean);
    if (matched.length !== orphans.length) return false;
    matched.forEach((item) => rebuyCart.removeItem(item));
    return true;
  }

  function removeViaCartApi(orphans) {
    const updates = {};
    orphans.forEach((orphan) => {
      updates[orphan.key] = 0;
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
  }

  function sweepOrphanChargers() {
    if (sweeping) return;
    sweeping = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const orphans = findOrphanChargers(cart.items || []);
        if (!orphans.length) return null;
        if (removeViaRebuy(orphans)) return null;
        return removeViaCartApi(orphans);
      })
      .catch(() => {})
      .finally(() => {
        sweeping = false;
      });
  }

  let debounceTimer = null;
  function scheduleSweep() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sweepOrphanChargers, 400);
  }

  document.addEventListener('rebuy:smartcart.line-item-removed', scheduleSweep);
  document.addEventListener('rebuy:smartcart.line-item-decrease', scheduleSweep);
  document.addEventListener('rebuy:smartcart.ready', scheduleSweep);
  document.addEventListener('rebuy:cart.change', scheduleSweep);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSweep);
  } else {
    scheduleSweep();
  }
})();
